// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"75fc48e6","455":"b197af70","977":"c5c0afab"}[chunkId] + ".chunk.js";
};